import { action, computed, observable } from 'mobx';
import { Api } from '../../../api/Api';

export declare interface IAddMealStore {
  date: string;
  getDate: () => Date;
  setDate: (date: string) => void;
  time: string;
  setTime: (time: string) => void;
  description: string;
  setDescription: (desc: string) => void;
  photo: Blob | null;
  setPhoto: (photo: Blob | null) => void;
  valid: boolean;
  submit: () => Promise<void>;

}

export class AddMealStore implements IAddMealStore {

  @observable private _date : Date;
  @observable private _dateStr: string;
  @observable private _time: string;
  @observable private _description: string;
  @observable private _valid: boolean = false;
  @observable private _photo: Blob | null;

  private readonly _api: Api;

  constructor(api: Api) {
    this._api = api;
    this.reset();
  }

  @computed get date() {
    return this._dateStr;
  }

  public getDate() {
    return this._date;
  }

  @action public setDate(date: string) {
    const s = date.split('-');
    this._date.setFullYear(Number(s[0]));
    this._date.setMonth(Number(s[1]));
    this._date.setDate(Number(s[2]));
    this._dateStr = date;
    this.validate();
  }

  @computed get time() {
    return this._time;
  }

  @action public setTime(time: string) {
    const s = time.split(':');
    this._date.setHours(Number(s[0]));
    this._date.setMinutes(Number(s[1]));
    this._time = time;
    this.validate();
  }

  @action public reset() {
    const date = new Date();
    date.setSeconds(0);
    date.setMilliseconds(0);
    this._date = date;
    this._time = `${this._localeString(date.getHours())}:${this._localeString(date.getMinutes())}`;
    this._dateStr = this._date.toISOString().slice(0, 10);
    this._description = '';
    this._photo = null;
  }

  @computed get description() {
    return this._description;
  }

  @action public setDescription(description: string) {
    this._description = description;
    this.validate();
  }

  @computed get photo() {
    return this._photo;
  }

  @action public setPhoto(photo: Blob | null) {
    this._photo = photo;
  }

  @action public submit() {
    return this._api.addMeal({
      description: this.description,
      zonedTimestamp: this._date
    }, this._photo).then(() => {
      this.reset();
    });
  }

  @computed get valid() {
    return this._valid;
  }

  @action public validate() {
    let valid = true;
    if (!this._time) {
      valid = false;
    }
    if (!this._dateStr) {
      valid = false;
    }
    if (!this._description) {
      valid = false;
    }
    this._valid = valid;
  }

  private _localeString(n: number) {
    return n.toLocaleString(undefined, {minimumIntegerDigits: 2});
  }

}



// WEBPACK FOOTER //
// ./src/diary/meal/add/AddMealStore.ts